module.exports = __webpack_public_path__ + "img/custom3.3c5afe4c.png";